import React, { FC, useEffect, useState } from 'react';
import { Card, Typography } from '@mui/material';

import { ShsRadioButtonGroup, ShsSelectInput, ShsTextInput, ShsToggle } from '../../common';
import { SubjectControlsGrid } from './SubjectControlsGrid';
import {
    HIGH_SCHOOL_GRADES_LABELS,
    JUNIOR_SCHOOL_GRADES_LABELS,
    PRE_SCHOOL_YEARS_LABELS,
    CONSULTATION_TYPE,
    SUBJECT_TYPE
} from '../../../constants';
import { Theme } from 'src/Theme';
import { CONSULTATION_DURATION, CONSULTATION_TYPE_LIST, SUBJECTS_LIST } from '../common/const';
import { useFormContext, useWatch } from 'react-hook-form';

const separatorStyles = { mb: 1, mt: 3 };

export const SubjectsCreateCard: FC<{ serverError: string | null }> = ({ serverError }) => {
    const [isReset, setIsReset] = useState(false);
    const { subject_type } = useWatch();
    const { unregister } = useFormContext();
    const form = useFormContext();

    const isPsychologySubjectType = subject_type === SUBJECT_TYPE.PSYCHOLOGY;
    const isForeignSubjectType = subject_type === SUBJECT_TYPE.FOREIGN;

    if (isForeignSubjectType) {
        if (!isReset) {
            PRE_SCHOOL_YEARS_LABELS.map((item) => form.resetField(`planning.${item.planningSourceName}`));
            setIsReset(true);
        }
    }

    useEffect(() => {
        if (isPsychologySubjectType) {
            unregister('planning');
        } else {
            unregister('consultationType');
            unregister('durationMinutes');
        }
    }, [subject_type, unregister]);

    return (
        <Card sx={{ width: '100%', mb: 2, p: 4 }}>
            <ShsTextInput required source={'name'} label="Назва предмету" name={'name'} />
            {serverError && (
                <Typography color="error" sx={{ mb: 2 }}>
                    {serverError}
                </Typography>
            )}
            <ShsRadioButtonGroup
                row={false}
                sx={{ color: Theme.palette.primary.midnightBlue }}
                source={'subject_type'}
                defaultValue={SUBJECT_TYPE.NORMAL}
                choices={SUBJECTS_LIST}
                label="Тип предмету"
                onChange={() => setIsReset(false)}
                required
            />
            {isPsychologySubjectType ? (
                <>
                    <ShsRadioButtonGroup
                        row={false}
                        sx={{ color: Theme.palette.primary.midnightBlue }}
                        source={'consultationType'}
                        defaultValue={CONSULTATION_TYPE.WITH_PUPILS}
                        choices={CONSULTATION_TYPE_LIST}
                        label="Психологія"
                        required
                    />

                    <ShsSelectInput
                        source="durationMinutes"
                        label="Тривалість консультації"
                        choices={CONSULTATION_DURATION}
                        defaultValue={40}
                        required
                        isTruncatedOptions
                        style={{ width: '70px' }}
                    />
                </>
            ) : (
                <>
                    {!isForeignSubjectType && (
                        <Typography fontSize="16px" fontWeight="500" sx={{ ...separatorStyles }}>
                            Дошкільна освіта
                        </Typography>
                    )}
                    {!isForeignSubjectType && <SubjectControlsGrid schoolPlanning={PRE_SCHOOL_YEARS_LABELS} />}
                    <Typography fontSize="16px" fontWeight="500" sx={{ ...separatorStyles }}>
                        1-4 класи
                    </Typography>
                    <SubjectControlsGrid schoolPlanning={JUNIOR_SCHOOL_GRADES_LABELS} />
                    <Typography fontSize="16px" fontWeight="500" sx={{ ...separatorStyles }}>
                        5-11 класи
                    </Typography>
                    <SubjectControlsGrid schoolPlanning={HIGH_SCHOOL_GRADES_LABELS} />
                </>
            )}
        </Card>
    );
};
